// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Components
// import Component from '~/components/componentName';

/**********
 ** Component: IconCheck
 ** @type: functional stateless component
 ** @description:  componentDescription
 **********/
const IconAlert = props => {
	const { showTooltip, tooltipLeft, invertColors, bgColor, fillColor, size } = props;
	return (
		<Figure size={size}>
			<Icon
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 286.054 286.054"
				aria-labelledby="icon-copy-title"
				size={size}
				bgColor={invertColors ? fillColor : bgColor}
			>
				<g>
					<path
						fill={invertColors ? bgColor : fillColor}
						d="M143.027,0C64.04,0,0,64.04,0,143.027c0,78.996,64.04,143.027,143.027,143.027
			c78.996,0,143.027-64.022,143.027-143.027C286.054,64.04,222.022,0,143.027,0z M143.027,259.236
			c-64.183,0-116.209-52.026-116.209-116.209S78.844,26.818,143.027,26.818s116.209,52.026,116.209,116.209
			S207.21,259.236,143.027,259.236z M143.036,62.726c-10.244,0-17.995,5.346-17.995,13.981v79.201c0,8.644,7.75,13.972,17.995,13.972
			c9.994,0,17.995-5.551,17.995-13.972V76.707C161.03,68.277,153.03,62.726,143.036,62.726z M143.036,187.723
			c-9.842,0-17.852,8.01-17.852,17.86c0,9.833,8.01,17.843,17.852,17.843s17.843-8.01,17.843-17.843
			C160.878,195.732,152.878,187.723,143.036,187.723z"
					/>
				</g>
			</Icon>
			{showTooltip ? (
				<span className={`${tooltipLeft ? 'left' : 'right'} tooltiptext`}>Incomplete profile information</span>
			) : (
				''
			)}
		</Figure>
	);
};

const Figure = styled.figure`
	display: inline-flex;
	width: ${props => `${props.size}px`};
	height: ${props => `${props.size}px`};
	border-radius: 50%;
	position: relative;
	pointer-events: all;
	.tooltiptext {
		line-height: 100%;
		font-size: 16px;
		visibility: hidden;
		width: 150px;
		background-color: black;
		color: #fff;
		text-align: center;
		border-radius: 6px;
		padding: 5px 0;
		position: absolute;
		z-index: 1;
		top: -10px;
		right: 130%;
	}
	.right.tooltiptext {
		left: 130%;
	}

	.tooltiptext::after {
		content: '';
		position: absolute;
		top: 50%;
		left: 100%;
		margin-top: -5px;
		border-width: 5px;
		border-style: solid;
		border-color: transparent transparent transparent black;
	}
	.right.tooltiptext::after {
		left: auto;
		right: 100%;
		border-color: transparent black transparent transparent;
	}
	&:hover .tooltiptext {
		visibility: visible;
	}
`;
const Icon = styled.svg`
	width: ${props => `${props.size}px`};
	height: ${props => `${props.size}px`};
	background-color: ${props => `${props.bgColor}`};
	border-radius: 50%;
`;

IconAlert.defaultProps = {
	size: 20,
	invertColors: false,
	tooltipLeft: true,
	showTooltip: true,
	bgColor: 'transparent',
	fillColor: '#FFB900',
};

IconAlert.propTypes = {
	size: PropTypes.number,
	invertColors: PropTypes.bool,
	tooltipLeft: PropTypes.bool,
	showTooltip: PropTypes.bool,
	bgColor: PropTypes.string,
	fillColor: PropTypes.string,
};

export default IconAlert;



// WEBPACK FOOTER //
// ./src/components/ui/layout/icons/icon-alert.jsx